import { render, staticRenderFns } from "./LangPair.vue?vue&type=template&id=3381e80e&scoped=true&"
import script from "./LangPair.vue?vue&type=script&lang=js&"
export * from "./LangPair.vue?vue&type=script&lang=js&"
import style0 from "./LangPair.vue?vue&type=style&index=0&id=3381e80e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3381e80e",
  null
  
)

export default component.exports